import React, { useEffect, useState } from 'react'
import styles from './gridStyles.module.scss'
import {logo, eduIcon2, average} from '../../../assets/img/dashCategoris'
import {image10} from '../../../assets/img/dashCriterias'
import { arrowLeft, checkGreen, closeIcon, questionIcon } from '../../../assets/svg/dashboard/main'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getEgeDetails, getEgeStudents, getPhoto } from '../../../actions/dashboard'
import ProgressBar from '../../../assets/ProgressBar'
import { Check } from '../../../assets/NewDashboard'
import Modal from 'react-responsive-modal'
import { IoIosClose } from 'react-icons/io'
import { IoPerson } from "react-icons/io5";
import Tooltip from 'react-tooltip'
import { DASHBOARD_ENTITIES } from '../../../utils/const'
import { Input, Select } from '../../../assets/NewDashboard'
import { PiSortAscending, PiSortDescending } from "react-icons/pi";



const DISCIPLINES = [
  {name: 'Математика', key: '', pointsKey: 'avg_math'},
  {name: 'Русский язык', key: '', pointsKey: 'avg_russ'},
  {name: 'Информатика', key: '', pointsKey: 'avg_info'},
  {name: 'Физика', key: '', pointsKey: 'avg_phys'},
  {name: 'История', key: '', pointsKey: 'avg_hist'},
  {name: 'География', key: '', pointsKey: 'avg_geog'},
  {name: 'Иностранный язык', key: '', pointsKey: 'avg_lang'},
  {name: 'Обществознание', key: '', pointsKey: 'avg_social'},
  {name: 'Химия', key: '', pointsKey: 'avg_chemistry'},
  {name: 'Биология', key: '', pointsKey: 'avg_biology'},
  {name: '', key: 'pass_course_name1', pointsKey: 'avg_pass_course1'},
  {name: '', key: 'pass_course_name2', pointsKey: 'avg_pass_course2'},
  {name: '', key: 'pass_course_name3', pointsKey: 'avg_pass_course3'},
  {name: '', key: 'pass_course_name4', pointsKey: 'avg_pass_course4'},
]

const Details = () => {
  
  const history = useHistory()
  const dispatch = useDispatch()
  const {id} = useParams()
  const { details, loading } = useSelector(state => state.dashboard)

  const [user, setUser] = useState(null)
  const [filters, setFilters] = useState({fio: '', order_by: '', sort_order: 'asc'})
  
  useEffect(() => {
    dispatch(getEgeDetails(id))
  }, [])
  

  useEffect(() => {
    dispatch(getEgeStudents(id, filters))
  }, [filters])

  const goTo = (link) => () => history.push(link) 
  
  const { mpid_stats, subjects_stats, students } = details.ege
  const { avg_dvi, avg_ege, ege_result, name } = mpid_stats


  const renderDiscipline = (item) => {
    const {name, key, pointsKey} = item
    if (!Object.keys(subjects_stats).length) return;
    const discName = name || subjects_stats[key] || 'Доп предмет'
    const points = subjects_stats[pointsKey]
    if (points === -1) return;
    return (
      <li>
        <img src={image10} alt={name} />
        <p>{discName}</p>
        <p>{points || '0'}</p>
        <p>баллов</p>
      </li>
    )
  }

  if (ege_result < 0) return <h1 className={styles.notAllowed}>Не учитывается</h1>

  const { min, max, options } = DASHBOARD_ENTITIES.high.ege

  return (
    <div>
        <UserModal
          specialization={name}
          open={!!user}
          close={() => setUser(null)}
          data={user}
        />
        <section className={`${styles.detailsWrap} ${styles.egeDetailsWrap}`}>
          <div onClick={goTo('/dashboard_new/accreditation')}>
            <div>{arrowLeft}</div>
            <h2>{name}</h2>
          </div>
          <div className={styles.dashBlock}>
            <section className={styles.firstSection}>
              <div>
                <div>
                  <div>
                    <img src={eduIcon2} alt='о_О' />
                  <p className={styles.pStyles}>Средний балл <br/> поступивших по <br/> ЕГЭ и ДВИ</p>
                  </div>
                </div>
                <div style={{right: '1.5rem'}}>
                  <div>
                    <p>{avg_ege}</p>
                    <p>баллов</p>
                  </div>
                  <ProgressBar
                    percent={avg_ege}
                    max={10}
                    width={80}
                    height={150}
                    colorEnd='#ffeb00'
                    colorStart='#0bc106'
                  />
                </div>
              </div>
              <div>
                <div>
                  <i data-tip='custom-jsx-tooltip' data-for="custom-jsx-tooltip">{questionIcon}</i>
                  <Tooltip id="custom-jsx-tooltip" className={styles.tooltip}>
                    <p>Критериальное значение аккредитационного показателя</p>
                    <ul>{options.map((i) => <li>{i}</li>)}</ul>
                  </Tooltip>
                  <Check
                    className={styles.checkBlock}
                    mode={ege_result >= max ? `complete` : ege_result <= min ? `notComplete` : `middle`}
                  />
                </div>
                <p>{ege_result}</p>
                <p>баллов</p>
                <p>аккредитационного</p>
                <p>показателя</p>
              </div>
            </section>
            <section className={styles.secondSection}>
              <div>
                <Input
                  placeholder='поиск'
                  onChange={(fio) => setFilters({...filters, fio})}
                />
                <Select
                  value={filters.order_by}
                  onChange={(e) => setFilters({...filters, order_by: e.target.value})}
                >
                  <option selected hidden>Сортировать по</option>
                  <option value='fio'>ФИО</option>
                  <option value='avg_ege'>Средний балл</option>
                  <option value='faculty'>Факультет</option>
                  <option value='group'>Группа</option>
                </Select>
                <div 
                  className={styles.sortIcon}
                  onClick={() => setFilters({...filters, sort_order: filters.sort_order === 'asc' ? 'desc' : 'asc'})}
                >
                  {filters.sort_order === 'asc' ? <PiSortAscending /> : <PiSortDescending />}
                </div>
              </div>
              <div>
                {!!students?.length && <ul>{students?.map(user => <User key={user.mid} setModal={setUser} user={user} />)}</ul>}
                {!students?.length && <div className={styles.noData}>Данные отсутствуют</div>}
              </div>
            </section>
            <section className={styles.thirdSection}>
              <ul>
                {DISCIPLINES.map(renderDiscipline)}
              </ul>
            </section>
          </div>
        </section>
    </div>
  )
}



const User = ({user, setModal}) => {
  
  const { mid, faculty, group_name, fio, avg_total } = user
  const position = [faculty, group_name].filter(Boolean).join(', ')
  
  const dispatch = useDispatch()
  
  const [photo, setPhoto] = useState('')
  
  useEffect(async () => {
    const photoUrl = await dispatch(getPhoto(mid))
    setPhoto(photoUrl)
  }, [user])
  
  const userClickHandler = () => {
    setModal({...user, photo})
  }

  return (
    <li onClick={userClickHandler} className={styles.userBlock}>
      <div>
        {photo ? <img src={photo} alt="photo" /> : <IoPerson size={50} color='#5c76e3'/>}
      </div>
      <div>
        <p>{fio}</p>
        <p>{position}</p>
      </div>
      <div>
        <img src={average} alt="experience" />
        <div style={{top: 'calc(50% - 4px)'}}>
          <p>{avg_total}</p>
        </div>
      </div>
    </li>
)}


const UserModal = ({open, close, data, specialization}) => {
  
  
  const { mid, faculty, group_name, fio, avg_total, photo, marks } = data || {}
  const position = [faculty, group_name].filter(Boolean).join(', ')
  
  const renderMark = (item) => {
    const {name, key, pointsKey} = item
    if (!Object.keys(marks || {}).length) return;
    const discName = name || marks[key] || 'Доп предмет'
    const points = marks[pointsKey]
    if (points === -1) return;
    return (
      <li>
        <p>{discName}</p>
        <p>{points || '0'}</p>
      </li>
    )
  }

  return (
    <Modal
      open={open}
      onClose={close}
      classNames={{modal: styles.userModal}}
      showCloseIcon={false}
      center
    >
      <section>
        <div>
        {photo ? <img src={photo} alt="photo" /> : <IoPerson size={70} color='#5c76e3'/>}
        </div>
        <div>
          <p>{fio}</p>
          <p>{position}</p>
        </div>
      </section>
      <p>{specialization}</p>
      <IoIosClose color='#C42F2C' size={70} onClick={close}/>
      <section>
        <div>
          <img src={average} alt="experience" />
          <div style={{top: 'calc(50% - 4px)'}}>
            <p>{avg_total}</p>
          </div>
        </div>
        <ul>
          {DISCIPLINES.map(renderMark)}
        </ul>
      </section>
    </Modal>
  )
}

export default Details